import React from 'react'

export const WhatsAppFillSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0004 2.3999C6.69879 2.3999 2.40039 6.6983 2.40039 11.9999C2.40039 13.8009 2.90626 15.48 3.76914 16.9202L2.48633 21.5999L7.26602 20.3452C8.66387 21.14 10.2776 21.5999 12.0004 21.5999C17.302 21.5999 21.6004 17.3015 21.6004 11.9999C21.6004 6.6983 17.302 2.3999 12.0004 2.3999ZM8.71445 7.52178C8.87045 7.52178 9.03074 7.52083 9.16914 7.52803C9.34034 7.53203 9.52668 7.54456 9.70508 7.93896C9.91708 8.40776 10.3787 9.58383 10.4379 9.70303C10.4971 9.82223 10.539 9.96265 10.4566 10.1187C10.3782 10.2787 10.3375 10.3755 10.2223 10.5171C10.1031 10.6547 9.97245 10.8256 9.86445 10.9296C9.74525 11.0488 9.62217 11.1795 9.75977 11.4171C9.89737 11.6547 10.3752 12.4336 11.0816 13.0624C11.9896 13.8736 12.7557 14.1229 12.9941 14.2421C13.2325 14.3613 13.3706 14.3427 13.5082 14.1827C13.6498 14.0267 14.1029 13.4914 14.2629 13.253C14.4189 13.0146 14.5781 13.0559 14.7941 13.1343C15.0133 13.2127 16.1823 13.7885 16.4207 13.9077C16.6591 14.0269 16.8154 14.0859 16.8754 14.1827C16.937 14.2827 16.9371 14.7588 16.7395 15.314C16.5419 15.8684 15.5715 16.4045 15.1363 16.4421C14.6971 16.4829 14.2872 16.6395 12.2816 15.8499C9.86244 14.8971 8.33678 12.4193 8.21758 12.2593C8.09838 12.1033 7.24883 10.971 7.24883 9.80303C7.24883 8.63103 7.86332 8.05705 8.07852 7.81865C8.29772 7.58025 8.55445 7.52178 8.71445 7.52178Z"
        fill="black"
      />
    </svg>
  )
}
